module.exports = __webpack_public_path__ + "img/logo.a7fbe7c9.png";